export var AccountingReportDateOption;
(function (AccountingReportDateOption) {
    AccountingReportDateOption["Today"] = "today";
    AccountingReportDateOption["EndThisMonth"] = "endThisMonth";
    AccountingReportDateOption["EndLastMonth"] = "endLastMonth";
    AccountingReportDateOption["EndLastQuarter"] = "endLastQuarter";
    AccountingReportDateOption["EndLastFinancialYear"] = "endLastFinancialYear";
    AccountingReportDateOption["Custom"] = "custom";
})(AccountingReportDateOption || (AccountingReportDateOption = {}));
export var TrialBalanceGroupByOption;
(function (TrialBalanceGroupByOption) {
    TrialBalanceGroupByOption["GlAccount"] = "glAccount";
    TrialBalanceGroupByOption["TransactionType"] = "transactionType";
})(TrialBalanceGroupByOption || (TrialBalanceGroupByOption = {}));
export var IncomeStatementDateOption;
(function (IncomeStatementDateOption) {
    IncomeStatementDateOption["CurrentQuarter"] = "currentQuarter";
    IncomeStatementDateOption["LastQuarter"] = "lastQuarter";
    IncomeStatementDateOption["FinancialYearToDate"] = "financialYearToDate";
    IncomeStatementDateOption["LastFinancialYear"] = "lastFinancialYear";
    IncomeStatementDateOption["Custom"] = "custom";
})(IncomeStatementDateOption || (IncomeStatementDateOption = {}));
//# sourceMappingURL=index.js.map